// extracted by mini-css-extract-plugin
export default {"aboutUs":"AboutUs_aboutUs__IWMdP","bgImageWrapper":"AboutUs_bgImageWrapper__itHc3","container":"AboutUs_container__Qid3y","icon":"AboutUs_icon__gJAXs"};